<template lang="html">
    <li class="main-menu__item">
        <router-link v-bind:to="{ name: 'Users'}" v-bind:class="{[settingsLinkActiveClass]: settingLink == 'Users'}">
            <span>Пользователи</span>
        </router-link>
    </li>
</template>
<script>
    export default {
        name: 'user-settings-menu',
        sort: 10,
        module: 'user',
        data() {
            return {
                sort: 10,
                module: 'user'
            }
        },
        computed: {
            settingsLinkActiveClass() {
                return this.$router.options.settingsLinkActiveClass;
            },
            settingLink() {
                if (!this.$route.meta || !this.$route.meta.setting_link) return '';
                return this.$route.meta.setting_link
            }            
        }
    }
</script>



// WEBPACK FOOTER //
// SettingsMenu.vue?6b3c1d20